export const orderStatusKeysConst = {
  PENDING: 1,
  ACCEPTED: 2,
  READY_TO_PICK: 3,
  ASSIGNED_TO_TEAM: 4,
  ASSIGNED_TO_DRIVER_BY_ADMIN: 5,
  ORDER_ACCEPTED_BY_DRIVER: 6,
  REACHED_PICKUP_LOCATION: 7,
  ORDER_PICKED_UP: 8,
  ON_THE_WAY: 9,
  DELIVERED: 10,
  CANCEL_BY_USER: 11,
  CANCEL_BY_ADMIN: 12,
  REQUEST_RETURN: 13,
  RETURN_ACCEPTED: 14,
  RETURN_REJECTED: 15,
  FACTORY_ACCEPTED: 16,
  FACTORY_REJECTED: 17,
  UNDELIVERED: 18,
  UNDELIVERED_RETURNED_TO_FACTORY: 19, //This status will marked by driver when he returns the order to factory
  UNDELIVERED_ORDER_REJECTED_BY_FACTORY: 20,
  UNDELIVERED_ORDER_RECEIVED_BY_FACTORY: 21, //new status which is used to return order to factory
  RETURNED_TO_STOCK: 22,
  PRODUCT_RECEIVED_QC: 23,

  RETURN_APPROVED_FULL_REFUND: 24,        // valid return → full refund
  RETURN_APPROVED_PARTIAL_REFUND: 25,     // partial issue → partial refund
  RETURN_REJECTED_USER_DAMAGE: 26,        // invalid / user damage
  RETURN_REJECTED_FRAUD: 27,              // fraud suspected
  ORDER_NOT_ACCEPTED: 28,

  ALL: 50
};

export const ORDER_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  READY_TO_PICK: 3,
  ASSIGNED_TO_TEAM: 4,
  ASSIGNED_TO_DRIVER_BY_ADMIN: 5,
  ACCEPTED_BY_DRIVER: 6,
  REACHED_PICKUP_LOCATION: 7,
  ORDER_PICKED_UP: 8,
  ONTHEWAY: 9,
  DELIVERED: 10,
  CANCEL_BY_USER: 11,
  CANCEL_BY_ADMIN: 12,
  RETURN_REQUESTED: 13,
  RETURN_ACCEPTED: 14,
  RETURN_REJECTED: 15,
  FACTORY_ACCEPTED: 16,
  FACTORY_REJECTED: 17,
  UNDELIVERED: 18, //By Driver
  UNDELIVERED_ORDER_RETURNED_TO_FACTORY: 19, //By Driver
  UNDELIVERED_ORDER_REJECTED_BY_FACTORY: 20, //By Factory
  UNDELIVERED_ORDER_RECEIVED_BY_FACTORY: 21, //new status which is used to return order to factory
  ALL: 50
}

export const orderStatusForInvoice = [2,3,4,5,6,7,8,9,10]

// Keys double as i18n keys - getQualityCheckStatus() maps a qcAction id back to
// the key and the template pipes it through `| translate`, so they must stay in
// sync with en.json/ar.json rather than being free-form English.
export const QC_STATUS = {
  RETURN_APPROVED_FULL_REFUND: 24,        // valid return → full refund
  RETURN_APPROVED_PARTIAL_REFUND: 25,     // partial issue → partial refund
  RETURN_REJECTED_USER_DAMAGE: 26,        // invalid / user damage
  RETURN_REJECTED_FRAUD: 27,              // fraud suspected
}